import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 6665F86B-B97E-4AB8-8476-06B045706183
 * name monitor-cellphone-star
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-cellphone-star.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MonitorCellphoneStarIcon = createSvgIcon(<><path d="M23,11H18A1,1 0 0,0 17,12V21A1,1 0 0,0 18,22H23A1,1 0 0,0 24,21V12A1,1 0 0,0 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16A2,2 0 0,0 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2M11.97,9L11,6L10.03,9H7L9.47,10.76L8.53,13.67L11,11.87L13.47,13.67L12.53,10.76L15,9H11.97Z" /></>, 'MonitorCellphoneStarIcon');
export default MonitorCellphoneStarIcon